module.exports = __webpack_public_path__ + "static/media/resilient-management.01d8ea18.png";